// @flow
import React, { Component } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepIcon from "@material-ui/core/StepIcon";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";

const styles = (theme: DictionaryType): DictionaryType => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#ececec",
    borderRadius: "5px",
    margin: "5px",
    padding: "5px"
  },
  connector: {
    color: "rgba(0,0,0,.4)",
    textAlign: "center",
    width: "8px",
    flexShrink: "0",
    opacity: "0.7",
    verticalAlign: "baseline"
  },
  label: {
    color: "inherit",
    fontWeight: "500",
    textTransform: "capitalize",
    fontSize: "0.875rem"
  },
  button: {
    color: theme.palette.primary.light,
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: "inherit"
    }
  }
});

type StyledBreadcrumbClassesType = {
  root: DictionaryType,
  connector: DictionaryType,
  label: DictionaryType,
  button: DictionaryType
};

type TabType = {
  label: string,
  component?: React$Element<*>
};

type StyledBreadcrumbStaesType = {
  activeStep: number
};

type StyledBreadcrumbPropsType = {
  step: number,
  tabs: Array<TabType>,
  classes: StyledBreadcrumbClassesType,
  onClick?: Function
};

class StyledBreadcrumb extends Component<
  StyledBreadcrumbPropsType,
  StyledBreadcrumbStaesType
> {
  constructor(props: StyledBreadcrumbPropsType) {
    super(props);
    this.state = {
      activeStep: props.step || 0
    };
  }

  componentDidUpdate(prevProps: StyledBreadcrumbPropsType) {
    if (prevProps.step !== this.props.step) {
      this.setState({ activeStep: this.props.step });
    }
  }

  handleChange = (index: number) => {
    this.setState({ activeStep: index });
    this.props.onClick && this.props.onClick(index);
  };

  render(): React$Element<*> | null {
    const classes = this.props.classes;
    const activeStep = this.state.activeStep;
    const Connector = (): React$Element<*> => (
      <div className={classes.connector}>/</div>
    );
    let container = null;
    const tabs = this.props.tabs;
    if (tabs && tabs.length > 0) {
      container = tabs[activeStep].component;
    }

    if (tabs && container) {
      return (
        <div>
          <Stepper
            activeStep={activeStep}
            connector={<Connector />}
            classes={{ root: classes.root }}
          >
            {tabs.map(
              (tab: TabType, index: number): * => {
                if (index <= activeStep) {
                  return (
                    <Step key={index}>
                      <StepLabel icon={null}>
                        {(index < activeStep && (
                          <Button
                            color="primary"
                            className={classes.button}
                            classes={{ label: classes.label }}
                            onClick={(): * => this.handleChange(index)}
                          >
                            {tab.label}
                          </Button>
                        )) || (
                          <Button disabled classes={{ label: classes.label }}>
                            {tab.label}
                          </Button>
                        )}
                      </StepLabel>
                    </Step>
                  );
                } else {
                  return null;
                }
              }
            )}
          </Stepper>
          {container}
        </div>
      );
    } else {
      return null;
    }
  }
}

export default withStyles(styles)(StyledBreadcrumb);
